import t from "./underscore.js";
import r from "./each.js";
import { ArrayProto as e } from "./_setup.js";
import p from "./_chainResult.js";
r(["pop", "push", "reverse", "shift", "sort", "splice", "unshift"], function (r) {
  var o = e[r];
  t.prototype[r] = function () {
    var t = this._wrapped;
    return null != t && (o.apply(t, arguments), ("shift" === r || "splice" === r) && 0 === t.length && delete t[0]), p(this, t);
  };
}), r(["concat", "join", "slice"], function (r) {
  var o = e[r];
  t.prototype[r] = function () {
    var t = this._wrapped;
    return null != t && (t = o.apply(t, arguments)), p(this, t);
  };
});
export { t as default };